import { createSlice } from '@reduxjs/toolkit';

const inferenceSlice = createSlice({
  name: 'inference',
  initialState: {
    entity: {
      runtimeName: '',
      runtimeStatus: '',
      runtimeUuid: '',
    },
    modelId: '',
    filter: '',
  },
  reducers: {
    storeInferenceDetails: (state, action) => {
      state.entity = {
        ...state.entity,
        ...action.payload.entity,
      };
      state.modelId = action.payload.modelId;
    },
    updateInferenceStatus: (state, action) => {
      state.entity.runtimeStatus = action.payload;
    },
    updateFilter: (state, action) => {
      state.filter = action.payload;
    },
  },
});

const {
  reducer: inferenceReducer,
  actions: { storeInferenceDetails, updateInferenceStatus, updateFilter },
} = inferenceSlice;

export {
  inferenceReducer,
  storeInferenceDetails,
  updateInferenceStatus,
  updateFilter,
};
